<template>
    <svg class="icon__header-logo" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 157.1 20" style="enable-background:new 0 0 157.1 20;" xml:space="preserve">
        <g>
            <defs>
                <rect id="SVGID_1_" width="157" height="20"/>
            </defs>
            <clipPath id="SVGID_2_">
                <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
            </clipPath>
            <g class="st0">
                <rect x="38.3" y="0.4" class="st1" width="5.5" height="18.1"/>
                <g>
                    <defs>
                        <rect id="SVGID_3_" width="157" height="20"/>
                    </defs>
                    <clipPath id="SVGID_4_">
                        <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
                    </clipPath>
                    <g class="st2">
                        <path class="st1" d="M64.3,14.3c-8.7-0.1-10.8-2.9-10.8-4.8c0-4.1,6.1-4.8,10.4-4.9c5.4-0.1,11.4,1.1,11.4,5
                            c0,2.2-2.3,3.3-2.9,3.6L68.1,10h-5.9c1,0.7,4.3,3.1,5.8,4.1C66.6,14.2,64.7,14.3,64.3,14.3 M64.3,0c-9.9,0-16.5,2.6-16.5,9.4
                            c0,6.6,6.6,9.5,16.5,9.5c3,0,6-0.3,9-1l2.8,2c1.5,0,4.9,0,6,0c-1.5-1.2-3.3-2.4-4.8-3.5c2.9-1.2,4.9-4,4.9-7.2
                            C82.2,2.6,74.5,0,64.3,0"/>
                        <path class="st1" d="M114.8,0.4h-5.6v7.3c-0.2,5.2-3.9,6.7-7.7,6.7c-4.8,0-9.3-1.3-9.3-6.7V0.4h-6.4V8c0.4,8.1,7.5,11,14.4,11
                            c10.6,0,14.6-4.4,14.6-11V0.4"/>
                        <rect x="119.1" y="0.4" class="st1" width="5.1" height="18.1"/>
                        <polygon class="st1" points="146.4,0.4 127.6,0.4 127.6,5.1 136.1,5.1 136.1,18.5 140,18.5 140,5.1 146.4,5.1 				"/>
                        <path class="st1" d="M17.2,14.6v-3.3H28c1.5,0,1.9,0.8,1.9,1.6c0,0.7-0.1,1.7-1.9,1.7H17.2 M17.2,7.6V4.5h10
                            c1.3,0,1.7,0.8,1.7,1.5c0,0.8-0.3,1.6-1.7,1.6L17.2,7.6 M28.3,0.7H13.7v17.8H29c6.9-0.2,6.4-6.2,4.3-8c-0.6-0.5-1.4-0.9-2.1-1.1
                            c4.1-1.9,3.5-6.8-0.1-8.2C30.2,0.8,29.3,0.7,28.3,0.7"/>
                        <path class="st1" d="M155.7,0.5c-0.8,3.2-1.2,4.8-1.6,6.8c-1.1-3.4-1.5-4.2-2.4-6.8h-3.5c1.3,2.9,2.7,6.3,4.6,11.3v6.7h2.1
                            l-0.1-7.5c0.6-2.2,1.2-5.5,2.4-10.5L155.7,0.5"/>
                        <path class="st1" d="M0,0.6v8.3c0,5.6,0.9,9.5,4.8,9.5c4.2,0,5.8-2.6,5.8-10.4V0.6H7v7.2c0,3.6-0.6,6-2.9,6S1.3,10.6,1.3,8V0.6
                            H0z"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "icon-header-logo"
}
</script> 

<style lang="css" scoped>
    .st0{clip-path:url(#SVGID_2_);}
    .st1{fill:#FFFFFF;}
    .st2{clip-path:url(#SVGID_4_);}
</style>